/**
 * Build a host-playback details DTO from /channels/now so the existing
 * Media Asset control plane is used — player never knows schedule selection.
 */
import { normalizeChannelNowPayload, resolveChannelAvodMode } from "../../video-player/tpg/ProgramScheduler";
import { resolveHostControlPlane } from "../../video-player/production/resolveHostControlPlane";
import { resolveChannelJoinStartTime } from "./channelPlaybackHelpers";

export function controlPlaneFromChannelNow(nowPayload, opts) {
  opts = opts || {};
  const normalized = normalizeChannelNowPayload(nowPayload);
  const mediaAsset = normalized.mediaAsset || {};
  const avodMode = resolveChannelAvodMode(
    normalized.advertising,
    (mediaAsset.metadata && mediaAsset.metadata.adCues) || []
  );

  const details = {
    media_asset: mediaAsset,
    title: mediaAsset.title || (normalized.channel && normalized.channel.title) || "",
    name: mediaAsset.title || "",
    description: "",
    video_type: mediaAsset.presentationKind === "live" ? 2 : 1,
  };

  const plane = resolveHostControlPlane(details, {
    siteFeatures: opts.siteFeatures || {},
    featureOverrides: Object.assign({}, opts.featureOverrides || {}, {
      live: true,
      channel: true,
      avod: avodMode.enableAvod,
    }),
    licenseeAllowlist: opts.licenseeAllowlist || null,
  });

  const joinStartTime = resolveChannelJoinStartTime(nowPayload);

  return {
    normalized: normalized,
    details: details,
    plane: plane,
    avodMode: avodMode,
    joinStartTime: joinStartTime,
  };
}

export default controlPlaneFromChannelNow;
